import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'


const initialState: { projectIds: number[], isReset: boolean } = { projectIds: [], isReset: false }

const ProjectSlice = createSlice({
    name: 'Project',
    initialState,
    reducers: {
        SET_PROJECT_IDS(state, action: PayloadAction<any>) {
            state.projectIds = action.payload
            state.isReset = false
        },
        RESET_PROJECT_ID(state, action: PayloadAction<any>) {
            state.projectIds = action.payload
            state.isReset = true
        }
    },
})

export const { SET_PROJECT_IDS, RESET_PROJECT_ID } = ProjectSlice.actions
export default ProjectSlice.reducer